import { Grid, makeStyles, Typography } from '@material-ui/core';
import {
  Visibility,
  VisibilityOff,
  FiberManualRecord,
} from '@material-ui/icons';
import Button from 'components/Button';
import i18n from 'i18n';
import { getDashboardSessionsGraphRequest } from 'modules/environments/actions';
import React from 'react';
import { connect } from 'react-redux';
import SessionHistoryGraph from './SessionHistoryGraph';
import styles from './styles';

const useStyles = makeStyles(styles);

interface AdvisorEnvironmentSessionsGraphProps {
  environmentUuid: string;
  getDashboardSessionsGraphRequest: ({ id, query }) => void;
}

const AdvisorEnvironmentSessionsGraph = ({
  environmentUuid,
  getDashboardSessionsGraphRequest,
}: AdvisorEnvironmentSessionsGraphProps) => {
  const classes = useStyles();

  const [showSessionsGraph, setShowSessionsGraph] = React.useState(false);

  const getDashboardSessionsGraph = React.useCallback(() => {
    getDashboardSessionsGraphRequest({
      id: environmentUuid,
      query: { period: '30d' },
    });
  }, [environmentUuid, getDashboardSessionsGraphRequest]);

  React.useEffect(() => {
    getDashboardSessionsGraph();
  }, [getDashboardSessionsGraph]);

  return (
    <Grid container>
      <Button
        startIcon={showSessionsGraph ? <VisibilityOff /> : <Visibility />}
        variant="outlined"
        onClick={() => {
          setShowSessionsGraph(prev => !prev);
        }}
        className={classes.sessionsGraphButton}
      >
        {i18n.t(
          showSessionsGraph
            ? 'HIDE_SESSIONS_GRAPH_KEY'
            : 'EXPAND_SESSIONS_GRAPH_KEY'
        )}
      </Button>

      {showSessionsGraph && (
        <Grid container>
          <Grid
            container
            justify="flex-end"
            className={classes.legendContainer}
          >
            <Grid item className={classes.labelsModal}>
              <Grid item>
                <Typography className={classes.filterText}>
                  {i18n.t(`ENVIRONMENT_DASHBOARD.LAST_30D`)}
                </Typography>
              </Grid>
              <FiberManualRecord className={classes.graphSessionsMax} />
              <Typography className={classes.graphLegendItem}>
                {i18n.t('ENVIRONMENT_DASHBOARD.SESSIONS_MAX_KEY')}
              </Typography>
            </Grid>
            <Grid item className={classes.labelsModal}>
              <FiberManualRecord className={classes.graphVacanciesMax} />
              <Typography className={classes.graphLegendItem}>
                {i18n.t('ENVIRONMENT_DASHBOARD.VACANCIES_MAX_KEY')}
              </Typography>
            </Grid>
          </Grid>
          <Grid container justify="center">
            <Grid item xs={10}>
              <SessionHistoryGraph />
            </Grid>
          </Grid>
        </Grid>
      )}
    </Grid>
  );
};

export default connect(null, { getDashboardSessionsGraphRequest })(
  AdvisorEnvironmentSessionsGraph
);
